import React, {useContext, useEffect, useState} from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { routingArray } from './config/RoutingList';
import Dashboard from '../app/Pages/Dashboard';
import Login from '../app/Pages/Login';
import Billing from '../app/Pages/Billing';
import ActiveUsers from '../app/Pages/ActiveUsers';
import ConnectedUsers from '../app/Pages/ConnectedUsers';
import Profile from '../app/Pages/Profile';
import ChangePassword from '../app/Pages/ChangePassword';
import SubUsers from '../app/Pages/SubUsers';
import AccountDetails from '../app/Pages/AccountDetails';
import Reports from '../app/Pages/Reports';
import DownloadAtomSDKs from '../app/Pages/DownloadSDKs';
import KeysManagement from '../app/Pages/KeysManagement';
import AdditionalDetail from '../app/Pages/AdditionalDetails';
import { useKeycloak } from '@react-keycloak/web';
import {checkPermission, getLocalStorage, setLocalStorage} from '../assets/utils/common_functions';
import PaymentEstimate from '../app/Pages/PaymentEstimate';
import PaymentInformation from '../app/Pages/PaymentInformation';
import DevelopmentScreen from '../app/modules/DevelopmentScreen';
import { decodeToken } from 'react-jwt';
import { useAbility } from '../configs/AbilityContext';
import { Spin } from 'antd';
import InvoiceDetails from '../app/Pages/Billing/InvoiceDetails';

const KEY_CLOAK_ENV = process.env.KEY_CLOAK_ENV;
const KEY_CLOAK_CLIENT_ID = process.env.KEY_CLOAK_CLIENT_ID
const KEY_CLOAK_REALM = process.env.KEY_CLOAK_REALM
const KEY_CLOAK_BASEURL = process.env.KEY_CLOAK_BASEURL

// Pages
const compList = {
  Dashboard,
  Login,
  Billing,
  ChangePassword,
  ActiveUsers,
  ConnectedUsers,
  AccountDetails,
  Profile,
  Reports,
  DownloadAtomSDKs,
  KeysManagement,
  AdditionalDetail,
  PaymentEstimate,
  PaymentInformation,
  DevelopmentScreen,
  SubUsers,
  InvoiceDetails
};

const Pages = () => {
    const { keycloak, initialized } = useKeycloak();
    const { ability, loading } = useAbility();
    const token = decodeToken(keycloak?.token)
    const [ready,setReady] = useState(true)
    const rolesObjects = token?.realm_access?.roles?.reduce((acc, role) => {
      if (role === 'paid_reseller') {
          acc['RESELLER'] = role;
      } else {
          acc[role.toUpperCase()] = role;
      }
      return acc;
  }, {});
    // Check readiness based on the initialized and loading state
    // Only render routes once ability data is available
    useEffect(() => {
        if ((initialized && loading && keycloak.authenticated) || (!initialized && loading)) {
            if(initialized && !getLocalStorage('authToken', true)){
                //We need to setStorage here because abilityProvider requires this;
                //Otherwise it will send empty authToken in acl/details
                setLocalStorage('authToken', keycloak?.token, true)
            }
            setReady(false);
        }
        else {
            setReady(true);
        }
    }, [initialized,loading]);

    const routeComponents = routingArray(rolesObjects).map(
      ({ title, component, path, permission }, key) => {
        return (
          <Route
            exact
            path={path}
            key={key}
            render={(props) => {
              // if not authenticated, redirect to login page
              if (keycloak?.authenticated == true) {
                const pathParts = path.split('/').filter(p => p && !p.startsWith(':')); 
                const basePath = pathParts.length > 0 ? `/${pathParts[0]}` : path;
                const pathToCheck = token?.realm_access?.roles?.includes("sub_user") ? basePath : path;
                if(ability.can('read', pathToCheck)){
                      const MyComponent = compList[title];
                      if (!permission) {
                          return <MyComponent Comp={component} {...props} />;
                      } else {
                          if (checkPermission(permission,token?.realm_access?.roles)) {
                              return <MyComponent Comp={component} {...props} />;
                          } else {
                              return <Redirect to='/dashboard' />;
                          }
                      }
                  }
                 else {
                     return <Redirect to='/dashboard' />;
                 }
              } else {
                localStorage.clear();
                window.location.replace(
                  `${KEY_CLOAK_BASEURL}/realms/${KEY_CLOAK_REALM}/protocol/openid-connect/auth?client_id=${KEY_CLOAK_CLIENT_ID
                  }&scope=openid%20profile%20email&redirect_uri=${KEY_CLOAK_ENV}&response_type=code`
                );
              }
            }
          }
          />
        );
      }
    );
    if (!ready) {
        // Show loading or some kind of spinner until abilities and Keycloak are ready
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh', // Full height of the viewport
            }}>
                <Spin size="large" tip="Loading..." />
            </div>
        );
    }
  return (
    initialized && (
      <Switch>
        <Route
          exact
          path='/'
          render={(props) => <Login Comp={'Login'} {...props} />}
        />
        {routeComponents}
      </Switch>
    )
  );
};

export default Pages;
